import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import {Col} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro objednávku dopravy.
 */
class ObjednavkaDopravyForm extends Component<WithTranslation> {

    static formName = 'ObjednavkaDopravyForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (values.pocetBaliku < 0) {
            errors.pocetBaliku = t('validation.parcel_count_positive');
        }
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.Number int label={t('parcel_count')} name="pocetBaliku" disabled={submitting} addonsAfter={<Col xs={10} />} />
                <ff.String label={t('note')} name="poznamkaDovoz" disabled={submitting} />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(reduxForm({
    form: ObjednavkaDopravyForm.formName,
    validate: ObjednavkaDopravyForm.validate,
})(ObjednavkaDopravyForm));
